module.exports = __webpack_public_path__ + "static/pipeline-75c79c77013c82780e6673c2f00bbfbe.mp4";